import { getMenus, getTenantList } from '@/api/iam';
import { createMenu } from '@/config/app';
import { AppUrl } from '@/config/nav';
import { defineStore } from 'pinia';
export interface AppProps {
  name: string;
  id: string;
  key: string;
  hasPerm: boolean;
  keyPattern: string;
  type: number;
  url?: string;
  childList: AppProps[];
  onlyQuery: boolean;
  sort: number;
}

interface State {
  app: AppProps[];
  tenant: any[];
  loadApp: boolean;
}

const enum AppKey {
  menu,
  page,
  btn,
}
// 获取有权限的app
function getApp(app: AppProps[]) {
  const result: AppProps[] = [];
  let temp;
  app.forEach((i) => {
    temp = { ...i };
    if (!i.hasPerm) {
      return;
    }
    if (i.type == AppKey.page && i.childList) {
      const rm = i.childList.find((k) => k.type == AppKey.menu);
      if (!rm) {
        return;
      }
      temp = { ...rm };
      if (rm.childList) {
        temp.childList = getApp(rm.childList);
      }
      result.push(temp);
      return;
    }
    if (i.type != AppKey.menu) {
      return;
    }
    if (temp.childList) {
      temp.childList = getApp(i.childList);
    }
    result.push(temp);
  });
  return result;
}

// 扁平化app
function getflatApp(app: AppProps[], flatApps: AppProps[]) {
  let temp;
  app.forEach((i) => {
    temp = { ...i };
    flatApps.push(temp);
    if (temp.childList) {
      getflatApp(i.childList, flatApps);
    }
  });
  return flatApps;
}

// useStore could be anything like useUser, useCart
// the first argument is a unique id of the store across your application
export const useIamAuthStore = defineStore<
  string,
  State,
  any,
  {
    getIamMenu: () => void;
    resetApp: () => void;
    fetchMenus: () => any;
    fetchTenantList: () => any;
    hasMenu: (keyPattern: string) => AppProps | undefined;
    getFirstUrl: () => string | null;
  }
>('iamApp', {
  state: () => {
    return {
      app: [],
      loadApp: false,
      tenant: [],
    };
  },
  getters: {
    // 权限app，筛选
    permApp() {
      return getApp(this.app);
    },
    menu() {
      return createMenu(this.permApp);
    },

    // 扁平化app
    flatApps() {
      const apps: AppProps[] = [];
      getflatApp(this.app, apps);
      return apps;
    },
    tenantObj() {
      return this.tenant.reduce((acc, tenant) => {
        acc[tenant.id] = tenant.name;
        return acc;
      }, {});
    },

    btnApps() {
      const apps = this.flatApps
        .filter((i) => i.type == 2 && i.hasPerm)
        .map((i) => i.keyPattern);
      return apps;
    },
  },
  actions: {
    async getIamMenu() {
      if (this.loadApp) {
        return;
      }

      return this.fetchMenus();
    },

    async fetchTenantList() {
      const { data } = await getTenantList();
      this.tenant = data;
      return data;
    },

    async fetchMenus() {
      const res = await getMenus();
      this.app = res.data;
      this.loadApp = true;
      return res.data;
    },

    // 是否有菜单
    hasMenu(keyPattern: string) {
      console.log(this.flatApps);
      return this.flatApps.find((i) => i.keyPattern === keyPattern);
    },

    getFirstUrl() {
      if (!this.permApp?.length) {
        return null;
      }
      const homeApp = this.permApp.find((i) => i.keyPattern == 'home');
      if (homeApp) {
        const upd = homeApp.keyPattern;
        const url = AppUrl[upd] || upd;
        const path = '/portal/' + url.replace('.', '/');
        return path;
      }
      const firstApp = this.permApp[0];
      if (firstApp && firstApp.childList.length > 0) {
        const upd = firstApp.childList[0].keyPattern;
        const url = AppUrl[upd] || upd;
        const path = '/portal/' + url.replace('.', '/');
        return path;
      }
      return null;
    },

    resetApp() {
      this.app = [];
      this.tenant = [];

      this.loadApp = false;
    },
  },
});
